import { useCreateCalendarMutation, useListCalendarsQuery } from '@/queries/calendar.queries';
import uuidService from '@/services/uuid.service';

export function useListCalendarsController() {
	const query = useListCalendarsQuery();
	const createCalendarMutation = useCreateCalendarMutation();

	function handleCreateCalendarClick() {
		return createCalendarMutation.mutateAsync({
			id: uuidService.v4(),
			name: `Calendar ${uuidService.slug()}`,
		});
	}
	return { query, handleCreateCalendarClick };
}
